import { Port } from './port';
export class FloatingPort extends Port {
    // a curve associated with the port
    // constructor
    constructor(curve, location) {
        super();
        this.curve = this.curve;
        this.location = location.clone();
    }
    // the location of the port
    get Location() {
        return this.location;
    }
    set Location(value) {
        this.location = value;
    }
    // translate the port location by delta
    Translate(delta) {
        this.location = this.location.add(delta);
    }
    // the port's curve
    get Curve() {
        return this.curve;
    }
    set Curve(value) {
        this.curve = value;
    }
}
//# sourceMappingURL=floatingPort.js.map